<script>
import Badge from './Badge';
export default {
  name: 'TarifIndicator',
  components: {
    Badge
  },
  props: {
    title: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false,
    };
  }
};
</script>

<template>
     <div id="tariffIndicator" v-if="show">
         <span class="title">{{ title }}</span>
         <Badge title="UP-Grade"/>
         <router-link class="tariff-link" :to="'/tariff'">
                <span>zum STARFACE-UP Tarif wechseln</span>
        </router-link>
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
#tariffIndicator {
    display: flex;
    margin-bottom: 22px;
    .title {
        font-weight: bold;
        padding-right: 8px;
    }
    .tariff-link {
        color:$orange;
        margin-left: auto;
    }
}
</style>
